// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"6cca1ab6","792":"18661da8"}[chunkId] + ".chunk.css";
};